import { TransferStoreWorkshopStateEnums, TransferStoreWorkshopTypeEnums } from "src/app/enum/transfer-store-workshop-enum";

export class TransferStoreWorkshopModel {
  transferStoreWorkshopId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  transferStoreWorkshopState: number = TransferStoreWorkshopStateEnums.open;
  dateTransferStoreWorkshop: Date = new Date();
  swBlock: boolean = false;
  type: number = TransferStoreWorkshopTypeEnums.cleaning;
  observation: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}